module.exports = __webpack_public_path__ + "static/media/organization.13f09bf6.png";